var map = {
	"./works/affida/affida.jpg": "1bea",
	"./works/affida/affidaSito.png": "d1e9",
	"./works/aggiudicare/aggiudicare.jpg": "df49",
	"./works/aggiudicare/aggiudicareSito.png": "fff4",
	"./works/aggiudicare/moaSito.png": "4e30",
	"./works/ags/ags.jpg": "77fb",
	"./works/ags/agsSito.png": "6a95",
	"./works/audix/audix.jpg": "4e37",
	"./works/audix/audixSito.png": "9f7c",
	"./works/bulkysoft/bulkysoft.jpg": "565e",
	"./works/bulkysoft/bulkysoftSito.png": "04b1",
	"./works/cosmicfestival/cosmicfestival.jpg": "898b",
	"./works/cosmicfestival/foto/2.jpg": "a5b7",
	"./works/cosmicfestival/foto/3.jpg": "9019",
	"./works/cosmicfestival/foto/4.jpg": "e1ea",
	"./works/cosmicfestival/foto/5.jpg": "6f26",
	"./works/cosmicfestival/foto/6.jpg": "6c9b",
	"./works/dorel/dorel.jpg": "81ef",
	"./works/dorel/dorelSito.png": "3469",
	"./works/illusionaryGhosts/foto/1.png": "c04e",
	"./works/illusionaryGhosts/foto/10.png": "7f64",
	"./works/illusionaryGhosts/foto/11.png": "b7ea",
	"./works/illusionaryGhosts/foto/12.png": "2b9b",
	"./works/illusionaryGhosts/foto/13.png": "1c44",
	"./works/illusionaryGhosts/foto/14.png": "8d8b",
	"./works/illusionaryGhosts/foto/15.png": "7b1d",
	"./works/illusionaryGhosts/foto/16.png": "b215",
	"./works/illusionaryGhosts/foto/17.png": "e531",
	"./works/illusionaryGhosts/foto/18.png": "6439",
	"./works/illusionaryGhosts/foto/19.png": "0dc5",
	"./works/illusionaryGhosts/foto/2.png": "0831",
	"./works/illusionaryGhosts/foto/20.png": "46a6",
	"./works/illusionaryGhosts/foto/21.png": "a373",
	"./works/illusionaryGhosts/foto/22.png": "1669",
	"./works/illusionaryGhosts/foto/23.png": "85d0",
	"./works/illusionaryGhosts/foto/24.png": "06cb",
	"./works/illusionaryGhosts/foto/25.png": "8c19",
	"./works/illusionaryGhosts/foto/26.png": "fc20",
	"./works/illusionaryGhosts/foto/27.png": "963b",
	"./works/illusionaryGhosts/foto/3.png": "5e8f",
	"./works/illusionaryGhosts/foto/4.png": "8790",
	"./works/illusionaryGhosts/foto/5.png": "619d",
	"./works/illusionaryGhosts/foto/6.png": "3ae8",
	"./works/illusionaryGhosts/foto/7.png": "96df",
	"./works/illusionaryGhosts/foto/8.png": "e609",
	"./works/illusionaryGhosts/foto/9.png": "c3d4",
	"./works/illusionaryGhosts/illusionaryGhosts.jpg": "dfd9",
	"./works/illusionaryGhosts/illusionaryGhostsSito.png": "f962",
	"./works/metawhales/metawhales.jpg": "e359",
	"./works/metawhales/metawhalesSito.png": "d94e",
	"./works/moa/moa.jpg": "2dfe",
	"./works/moa/moaSito.png": "b0b7",
	"./works/pavimentazionistar3/pavimentazionistar3.jpg": "e766",
	"./works/pavimentazionistar3/pavimentazionistar3Sito.png": "ef95",
	"./works/residenzeseicento/residenzeseicento.jpg": "8f50",
	"./works/residenzeseicento/residenzeseicentoSito.png": "22f3",
	"./works/womfest/womfest.jpg": "631d",
	"./works/womfest/womfestSito.png": "b2ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9eb4";